import React, { useEffect, useState } from "react";
import "./CreateJuryGroup.scss";
import { TitleBar } from "../../../../Global/TitleBar/TitleBar";
import { TopBar } from "../../../TopBar/TopBar";
import {
  GreyBackgroundButton,
  GreyBorderButton,
  RedBackgroundButton,
  RedBordButton,
} from "../../../../Global/GlobalButton";
import { useLocation, useNavigate } from "react-router-dom";
import {
  InputLabel,
  InputTextarea,
  InputType,
  SelectBorder,
} from "../../../../Global/GlobalFormElement";
import { RiDeleteBin6Fill } from "react-icons/ri";
import { IoMdAddCircleOutline } from "react-icons/io";
import { Description, RedContent } from "../../../../Global/GlobalText";
import { EXCHNAGE_URL, USER_EXCHNAGE_URL } from "../../../../../Url/Url";
import axios from "axios";
import { useSelector } from "react-redux";
import { toast } from "react-toastify";

export const CreateJuryGroup = () => {
  const [filters, setFilters] = useState([{ id: 1, selectedOption: 'Award Category', value: [] }]);
  const [pattern, setPattern] = useState(''); // State to hold the selected pattern
  const [loader, setLoader] = useState(false)
  const [searchTerm, setSearchTerm] = useState("");
  const [sortOrder, setSortOrder] = useState("newest");
  const [categories, setCategories] = useState([])
  const [entryFields, setEntryFields] = useState([]);
  const [registrationFields, setRegistrationFields] = useState([]);
  const [awardCategoryOptions, setAwardCategoryOptions] = useState([]);

  const [isEditMode, setIsEditMode] = useState(false);
  const [juryGroupId, setJuryGroupId] = useState(null);

  const eventIdGet = useSelector((state) => state?.users?.id);
  const eventId = String(eventIdGet);
  const addFilter = () => {
    setFilters([
      ...filters,
      { 
        id: filters.length + 1,
        selectedOption: 'Submission Id',
        value: ''
      }
    ]);
  };
  const handleRemoveFilter = (id) => {
    setFilters(filters.filter((filter) => filter.id !== id));
    setPattern('')
  };


  const handleCategorySelect = (filterId, selectedValue) => {
    setFilters(filters.map(filter => {
      if (filter.id === filterId && filter.selectedOption === 'Award Category') {
        return {
          ...filter,
          value: Array.isArray(filter.value) 
            ? [...filter.value, selectedValue]
            : [selectedValue]
        };
      }
      return filter;
    }));
  };

  const handleCategoryRemove = (filterId, categoryToRemove) => {
    setFilters(filters.map(filter => {
      if (filter.id === filterId && filter.selectedOption === 'Award Category') {
        return {
          ...filter,
          value: filter.value.filter(cat => cat !== categoryToRemove)
        };
      }
      return filter;
    }));
  };

  const location = useLocation();
  const { roundId, roundName } = location.state || {};
  const { editData } = location.state || {};
  console.log("rororoor", editData)


  useEffect(() => {
    if (editData) {
      setIsEditMode(true);
      setJuryGroupId(editData.group.id);

      const nameInput = document.querySelector("input[placeholder='G6']");
      if (nameInput) nameInput.value = editData.group.group_name;

      setPattern(editData.group.formula);

      const newFilters = [];

      if (editData.awardCategories.length > 0) {
        newFilters.push({
          id: 1,
          selectedOption: 'Award Category',
          value: editData.awardCategories.map(c => c.award_category)
        });
      } 

      editData.submissionFields.forEach((field, index) => {
        const valueObj = editData.submissionFieldValues.find(
          v => v.submission_field === field.submission_field
        );
        newFilters.push({
          id: newFilters.length + 1,
          selectedOption: `Submission Form: ${field.submission_field}`,
          value: valueObj ? valueObj.value : ''
        });
      });

      editData.entrantFields.forEach((field, index) => {
        const valueObj = editData.entrantFieldValues.find(
          v => v.entrant_field === field.entrant_field
        );
        newFilters.push({
          id: newFilters.length + 1,
          selectedOption: `Entrant Form: ${field.entrant_field}`,
          value: valueObj ? valueObj.value : ''
        });
      });

      if (editData.submissionIds && editData.submissionIds.length > 0) {
        const submissionIdValue = editData.submissionIds.join(', ');
        newFilters.push({
          id: newFilters.length + 1,
          selectedOption: 'Submission Id',
          value: submissionIdValue
        });
      }

      setFilters(newFilters);
    }
  }, [editData, entryFields, registrationFields]);

  useEffect(() => {
    const entryOptions = entryFields.map(field => ({
      value: `Submission Form: ${field.label}`,
      label: `Submission Form: ${field.label}`
    }));

    const registrationOptions = registrationFields.map(field => ({
      value: `Entrant Form: ${field.label}`,
      label: `Entrant Form: ${field.label}`
    }));

    const awardCategoryAlreadyUsed = filters.some(
      filter => filter.selectedOption === 'Award Category'
    );

    const defaultOptions = [
      {
        value: 'Award Category',
        label: 'Award Category',
        disabled: awardCategoryAlreadyUsed
      },
      {
        value: 'Submission Id',
        label: 'Submission Id',
        disabled: false
      }
    ];
    setAwardCategoryOptions([
      ...defaultOptions,
      ...entryOptions,
      ...registrationOptions
    ]);
  }, [entryFields, registrationFields, filters]);


  const getCategories = async () => {
    setLoader(true)
    try {
      let apiUrl = `${EXCHNAGE_URL}/allAwards?eventId=${eventId}&sortOrder=${sortOrder}`;
      if (searchTerm) {
        apiUrl += `&search=${searchTerm}`;
      }
      const response = await axios.get(apiUrl, {
        headers: {
          "Content-Type": "Application/json",
          authorization: `Bearer ${localStorage.getItem("token")}`,
        },
      });
      if (response.status === 200) {
        setCategories(response.data.data)
      }
    } catch (error) {
      console.log(error)
    }
  }

  const getFilteringCriteriaData = async () => {
    setLoader(true)
    try {
      const response = await axios.get(`${EXCHNAGE_URL}/fetchFormFields?eventId=${eventId}`, {
        headers: {
          "Content-Type": "application/json",
          authorization: `Bearer ${localStorage.getItem("token")}`
        },
      });
      if (response.status === 200) {
        toast.success("Fields Fetched Successfully.")
        const subData = response.data.formSchema;

        setEntryFields(subData.entryFields);
        setRegistrationFields(subData.registrationFields)
      }
    } catch (error) {

    }
  }
  useEffect(() => {
    getCategories();
    getFilteringCriteriaData()
  }, [eventId, searchTerm, sortOrder]);



  const generateInputComponent = (selectedOption, value, onChange,filterId) => {

    if (selectedOption === 'Award Category' && categories.length > 0) {
      return (
        <div className="award-category-wrapper">
          <div className="selected-categories">
            {Array.isArray(value) && value.map((category, index) => (
              <div key={index} className="category-tag">
                {category}
                <span 
                  className="remove-tag"
                  onClick={() => handleCategoryRemove(filterId, category)}
                >
                  ×
                </span>
              </div>
            ))}
          </div>
          <SelectBorder
            value=""
            onChange={(e) => {
              handleCategorySelect(filterId, e.target.value);
              e.target.value = ''; // Reset select after selection
            }}
          >
            <option value="">Select Award Category</option>
            {categories.map((category) => (
              <option 
                key={category.awardId} 
                value={category.category_name}
                disabled={Array.isArray(value) && value.includes(category.category_name)}
              >
                {category.category_name}
              </option>
            ))}
          </SelectBorder>
        </div>
      );
    }


    if (selectedOption === 'Submission Id' && selectedOption) {
      return (
        <InputTextarea
          placeholder={`Enter Submission Id `}
          value={value}
          onChange={onChange}
        >

        </InputTextarea>
      );
    }


    const [category, fieldName] = selectedOption.split(":").map(str => str.trim());


    if (category === "Submission Form" && entryFields) {
      const field = entryFields.find(f => f.label === fieldName);
      if (field) {
        return (
          <InputType
            placeholder={`Enter ${field.label} of Submission Form`}
            value={value}
            onChange={onChange}
          />
        );
      }
    }
    if (category === "Entrant Form" && registrationFields) {
      const field = registrationFields.find(f => f.label === fieldName);
      if (field) {
        return (
          <InputType
            placeholder={`Enter ${field.label} of Entrant Form`}
            value={value}
            onChange={onChange}
          />
        );
      }
    }

    return <InputType type="text" value={value} onChange={onChange} />;
  };


  const navigate = useNavigate();

  const generatePattern = () => {
    if (filters.length === 0) return '';

    const patternOr = filters.map((_, index) => `{${index + 1}}`).join(' OR ');
    const patternAnd = filters.map((_, index) => `{${index + 1}}`).join(' AND ');

    return {
      orPattern: patternOr,
      andPattern: patternAnd
    };
  };

  const { orPattern, andPattern } = generatePattern();

  const handlePatternUse = (patternType) => {
    if (patternType === 'OR') {
      setPattern(`${orPattern}`);
    } else if (patternType === 'AND') {
      setPattern(`${andPattern}`);
    }
  };

  const handleSelectChange = (id, selectedOption) => {
    setFilters(filters.map(filter =>
      filter.id === id ? { ...filter, selectedOption } : filter
    ));
  };
  const handleInputChange = (id, value) => {
    setFilters(filters.map(filter =>
      filter.id === id ? { ...filter, value } : filter
    ));
  };



  const handleSave = async () => {
    setLoader(true);

    const juryGroupName = document.querySelector("input[placeholder='G6']").value;
    if (!juryGroupName) {
      toast.error("Jury Group Name is required");
      setLoader(false);
      return;
    }

    const awardCategories = filters
      .filter(filter => filter.selectedOption === 'Award Category')
      .flatMap(filter => Array.isArray(filter.value) ? filter.value : []);

    const submissionFields = filters
      .filter((filter) => filter.selectedOption.startsWith("Submission Form"))
      .map((filter) => filter.selectedOption.split(": ")[1]);

    const entrantFields = filters
      .filter((filter) => filter.selectedOption.startsWith("Entrant Form"))
      .map((filter) => filter.selectedOption.split(": ")[1]);

    const submissionIds = filters
      .filter((filter) => filter.selectedOption === "Submission Id")
      .flatMap((filter) =>
        filter.value.split(',').map(id => id.trim()).filter(id => id)
      );

    const submissionValues = submissionFields.reduce((acc, field) => {
      const filter = filters.find(
        (f) => f.selectedOption === `Submission Form: ${field}`
      );
      if (filter) acc[field] = filter.value;
      return acc;
    }, {});

    const entrantValues = entrantFields.reduce((acc, field) => {
      const filter = filters.find(
        (f) => f.selectedOption === `Entrant Form: ${field}`
      );
      if (filter) acc[field] = filter.value;
      return acc;
    }, {});

    const baseRequestData = {
      roundId: roundId,
      eventId: eventId,
      name: juryGroupName,
      awardCategories,
      submissionFields,
      entrantFields,
      submissionIds,
      submissionValues,
      entrantValues,
      formula: pattern
    };

    const requestData = isEditMode
      ? { ...baseRequestData, juryGroupId: juryGroupId }
      : baseRequestData;

    try {
      const url = isEditMode
        ? `${USER_EXCHNAGE_URL}/create-group/${juryGroupId}`
        : `${USER_EXCHNAGE_URL}/create-group`;

      const method = isEditMode ? 'post' : 'post';

      const response = await axios[method](url, requestData, {
        headers: {
          "Content-Type": "application/json",
          authorization: `Bearer ${localStorage.getItem("token")}`,
        },
      });

      if (response.status === (isEditMode ? 201 : 201)) {
        toast.success(`Jury Group ${isEditMode ? 'updated' : 'created'} successfully`);
        navigate("/view-group");
      }
    } catch (error) {
      toast.error(`Failed to ${isEditMode ? 'update' : 'create'} Jury Group`);
      console.error(error);
    } finally {
      setLoader(false);
    }
  };


  return (
    <div>
      <div className="create_jury_group_data_div">
        <TitleBar title="Jury Round" />
        <div className="create_jury_group_data_white_bg">
          <TopBar
            titleheading={`${isEditMode ? 'Edit' : 'Create'} a Jury Group for ${roundName}`}
          />

          <div className="create_jury_group_column width_column">
            <InputLabel>Jury Group Name:</InputLabel>
            <InputType type="text" placeholder="G6" />
          </div>

          <div className="create_jury_group_column">
            <InputLabel>Filtering Criteria:</InputLabel>

            {filters.map((filter, index) => (
              <div key={filter.id} className="create_jury_group_select">
                <Description>{index + 1}</Description>
                <SelectBorder
                  style={{ color: "#777777" }}
                  className="group_select_one"
                  value={filter.selectedOption}
                  onChange={(e) => handleSelectChange(filter.id, e.target.value)}
                >

                  {awardCategoryOptions.map((option) => (
                    <option
                      key={option.value}
                      value={option.value}
                      disabled={option.disabled}
                      style={option.disabled ? { color: '#ccc', cursor: 'not-allowed' } : {}}
                    >
                      {option.label}
                    </option>
                  ))}

                </SelectBorder>

                <SelectBorder
                  style={{ color: "#777777" }}
                  className="group_select_two"
                >
                  <option value="newest">Is</option>
                  <option value="oldest">Is</option>
                </SelectBorder>


                {generateInputComponent(filter.selectedOption, filter.value, (e) => handleInputChange(filter.id, e.target.value),filter.id)}

                <RiDeleteBin6Fill
                  className="create_jury_group_remove"
                  onClick={() => handleRemoveFilter(filter.id)}
                />
              </div>
            ))}

            <div className="create_jury_group_btn">
              <RedBordButton
                className="create_jury_group_pluscontent"
                onClick={addFilter}
              >
                <IoMdAddCircleOutline />
                Add a Filtering Criteria
              </RedBordButton>
            </div>
          </div>

          <div className="create_jury_group_column">
            <InputLabel>Filtering Criteria Pattern:</InputLabel>
            <InputType
              type="text"
              value={pattern} // Display the selected pattern
              placeholder="(1) AND (2)"
              readOnly
            />
          </div>

          <div className="create_jury_group_column">
            <InputLabel>Pattern Suggestion:</InputLabel>

            <div className="create_jury_group_pattern">
              <div className="create_jury_group_pattern_sub">
                <Description>{`${orPattern ? orPattern : "No suggestion available yet"} `}</Description>
                <RedContent style={{ cursor: "pointer" }} onClick={() => handlePatternUse('OR')} >Use</RedContent>
              </div>
              <div className="create_jury_group_pattern_sub">
                <Description>{`${andPattern ? andPattern : "No suggestion available yet"}`}</Description>
                <RedContent style={{ cursor: "pointer" }} onClick={() => handlePatternUse('AND')}>Use</RedContent>
              </div>
            </div>
          </div>

          <div className="shortlist_butt">
            <GreyBorderButton
              onClick={() => {
                navigate("/jury-round");
              }}
            >
              Back to Jury Group(s) Listing
            </GreyBorderButton>

            <GreyBackgroundButton onClick={handleSave}>Save</GreyBackgroundButton>

          </div>
        </div>
      </div>
    </div>
  );
};
